document.addEventListener('DOMContentLoaded', function () {
    const mobileWebImages = document.getElementById('mobile-img-slider');
    if(mobileWebImages){
    const bannerSlider = new Splide('#mobile-img-slider', {
      type: 'loop',
      drag: 'free',
      perPage: 5,
      gap: '5rem',
      arrows: false,
      pagination: false,
      autoScroll: {
        speed: 2,
        pauseOnHover: true
      },
      breakpoints: {
        749: {
          perPage: 2,
          drag: 'free',
          gap: '20px'
        }
      },
    }).mount(window.splide.Extensions);
  }
  const desktopWebImages = document.getElementById('web-img-slider');
    if(desktopWebImages){
    const bannerSlider = new Splide('#web-img-slider', {
      type: 'loop',
      drag: 'free',
      perPage: 3,
      gap: '2rem',
      arrows: false,
      pagination: false,
      autoScroll: {
        speed: -2,
        pauseOnHover: true
      },
      breakpoints: {
        600: {
          perPage: 1,
          drag: 'free',
          gap: '0.5rem'
        }
      },
    }).mount(window.splide.Extensions);
  }
  });